/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { Storage } from '@ionic/storage';

// Services
import { LoggerService } from '../logger/logger.service';

// Types
import { StorageKey } from '../../../shared/types/storage';

@Injectable({ providedIn: 'root' })
export class StorageService {
  public _storage: Storage | null = null;

  private readonly logger = inject(LoggerService);
  private readonly storage = inject(Storage);

  constructor() {
    void this.init();
  }

  async init(): Promise<Storage | null> {
    try {
      this._storage = await this.storage.create();
      this.logger.consoleLog('StorageService', 'init', 'storage create successfully');
      return this._storage;
    } catch (ex) {
      this.logger.consoleError('StorageService', 'init', { error: ex });
      return null;
    }
  }

  setOnStorage(key: string, data: any): Observable<void> {
    return new Observable((observer) => {
      this.logger.consoleLog('StorageService', 'setOnStorage', { [key]: data });
      this.storage
        .set(key, data)
        .then(() => observer.next())
        .catch((error) => {
          this.logger.consoleError('StorageService', 'setOnStorage', { [key]: data, error });
          observer.error(error);
        });
    });
  }

  getFromStorage<T = unknown>(key: string): Observable<T> {
    this.logger.consoleLog('StorageService', 'getFromStorage', { key });
    return new Observable<T>((observer) => {
      this.storage
        .get(key)
        .then((data) => {
          this.logger.consoleLog('StorageService', 'getFromStorage', { [key]: data });
          observer.next(data as T);
        })
        .catch((error) => {
          this.logger.consoleError('StorageService', 'getFromStorage', { key, error });
          observer.error(error);
        });
    });
  }

  removeFromStorage(key: string): Observable<void> {
    this.logger.consoleLog('StorageService', 'removeFromStorage', { key });
    return new Observable<void>((observer) => {
      this.storage
        .remove(key)
        .then(() => observer.next())
        .catch((error) => {
          this.logger.consoleError('StorageService', 'removeFromStorage', { key, error });
          observer.error(error);
        });
    });
  }

  getFreezedState<T = unknown>(fromComponent?: string): Observable<T> {
    this.logger.consoleLog('StorageService', 'getFreezedState', { fromComponent });
    return this.getFromStorage<T>(StorageKey.FreezeLastState).pipe(
      switchMap((data) => {
        this.logger.consoleLog('StorageService', 'getFreezedState', { data });
        if (data) {
          return of(data);
        } else {
          return of({} as T);
        }
      }),
    );
  }
}
